/* Quick Delivery celebration overlay - plays once when a pincode check
   comes back quick_delivery_available (see assets/delivery-estimate.js).
   Builds its own DOM lazily on first play() so it costs nothing on pages
   that never trigger it. Pure CSS drives the animation (see
   quick-delivery-animation.css); this file just mounts, starts and
   auto-dismisses/cleans it up.

   Shown at most once per browser session (sessionStorage-gated) - a
   shopper re-checking the same or another pincode won't see it again.
   The overlay is also rebuilt from scratch on every play() rather than
   reused: the rocket/chrome/card/smoke elements each carry their own
   unconditional `animation: ... forwards`, so a reused DOM node would
   already be pinned at its first run's end frame (rocket gone, card
   faded out) - a second play would only restart the outer scrim,
   showing what looks like a truncated "end clip" of the animation. */
(function () {
  var DURATION_MS = 4600;
  var SESSION_KEY = 'minaki_qd_shown';
  var overlay = null;
  var headlineEl = null;
  var subEl = null;
  var pincodeEl = null;
  var dismissTimer = null;

  function build() {
    var el = document.createElement('div');
    el.className = 't4s-qd-overlay';
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    el.innerHTML =
      '<span class="t4s-qd-ray t4s-qd-ray--1"></span>' +
      '<span class="t4s-qd-ray t4s-qd-ray--2"></span>' +
      '<span class="t4s-qd-ray t4s-qd-ray--3"></span>' +
      '<span class="t4s-qd-sparkle t4s-qd-sparkle--1"></span>' +
      '<span class="t4s-qd-sparkle t4s-qd-sparkle--2"></span>' +
      '<span class="t4s-qd-sparkle t4s-qd-sparkle--3"></span>' +
      '<span class="t4s-qd-sparkle t4s-qd-sparkle--4"></span>' +
      '<div class="t4s-qd-chrome">' +
        '<span class="t4s-qd-chrome__badge"><span class="t4s-qd-chrome__badge-dot"></span>Delivery Alert</span>' +
        '<button type="button" class="t4s-qd-chrome__close" data-qd-close aria-label="Close">' +
          '<svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M5 5l14 14M19 5L5 19" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/></svg>' +
        '</button>' +
      '</div>' +
      '<span class="t4s-qd-puff" style="animation-delay:.06s"></span>' +
      '<span class="t4s-qd-puff" style="animation-delay:.25s;width:110px;height:110px;margin-left:-55px"></span>' +
      '<span class="t4s-qd-puff" style="animation-delay:.44s"></span>' +
      '<span class="t4s-qd-puff" style="animation-delay:.63s;width:130px;height:130px;margin-left:-65px"></span>' +
      '<span class="t4s-qd-puff" style="animation-delay:.81s"></span>' +
      '<svg class="t4s-qd-rocket" viewBox="0 0 88 192" fill="none">' +
        '<path d="M44 6C58 34 64 66 64 100v58H24v-58C24 66 30 34 44 6z" fill="#F7EFE1" stroke="#C9A463" stroke-width="1.2"/>' +
        '<path d="M44 6C38 22 33 42 30 62h28c-3-20-8-40-14-56z" fill="#8C4444"/>' +
        '<rect x="24" y="96" width="40" height="10" fill="#C9A463" opacity="0.9"/>' +
        '<circle cx="44" cy="78" r="12.5" fill="#F4EEDD" stroke="#C9A463" stroke-width="2"/>' +
        '<circle cx="44" cy="78" r="12.5" fill="none" stroke="#B7B7E8" stroke-width="0.8" opacity="0.6"/>' +
        '<path d="M24 106L8 148h16z" fill="#5E2C2C"/>' +
        '<path d="M64 106l16 42H64z" fill="#5E2C2C"/>' +
        '<rect x="30" y="150" width="28" height="14" rx="3" fill="#C9A463"/>' +
        '<g class="t4s-qd-rocket__flame">' +
          '<path d="M33 164 L44 190 L55 164 Z" fill="#F2B94D" opacity="0.95"/>' +
          '<path d="M38 164 L44 180 L50 164 Z" fill="#FFE9A8" opacity="0.92"/>' +
        '</g>' +
      '</svg>' +
      '<div class="t4s-qd-card">' +
        '<span class="t4s-qd-card__pincode" data-qd-pincode></span>' +
        '<span class="t4s-qd-card__rule"></span>' +
        '<p class="t4s-qd-card__headline" data-qd-headline></p>' +
        '<p class="t4s-qd-card__sub" data-qd-sub></p>' +
      '</div>';
    document.body.appendChild(el);
    headlineEl = el.querySelector('[data-qd-headline]');
    subEl = el.querySelector('[data-qd-sub]');
    pincodeEl = el.querySelector('[data-qd-pincode]');
    el.querySelector('[data-qd-close]').addEventListener('click', dismiss);
    return el;
  }

  function dismiss() {
    if (!overlay) return;
    overlay.classList.remove('is-active');
    if (dismissTimer) {
      clearTimeout(dismissTimer);
      dismissTimer = null;
    }
  }

  function alreadyShownThisSession() {
    try {
      return sessionStorage.getItem(SESSION_KEY) === '1';
    } catch (e) {
      return false; // storage unavailable (private mode etc.) - fail open, allow it
    }
  }

  function markShownThisSession() {
    try {
      sessionStorage.setItem(SESSION_KEY, '1');
    } catch (e) {}
  }

  function play(opts) {
    opts = opts || {};
    if (alreadyShownThisSession()) return;

    // Fresh DOM every time - see file header for why a reused node can't
    // just have its .is-active class toggled to restart the sequence.
    if (overlay) overlay.remove();
    overlay = build();

    headlineEl.textContent = opts.headline || 'Quick Delivery Unlocked!';
    subEl.textContent = opts.sub || 'Get it in 2 hours';
    pincodeEl.textContent = opts.pincode ? 'Pincode ' + opts.pincode : 'Quick Delivery';

    void overlay.offsetWidth; // force layout so the animation starts at frame 0
    overlay.classList.add('is-active');
    markShownThisSession();

    dismissTimer = setTimeout(dismiss, DURATION_MS);
  }

  window.MinakiQuickDelivery = { play: play };
})();
